module.exports = __webpack_public_path__ + "img/404.0da46be3.svg";